import React from 'react'
import styled from 'styled-components'
import { useProfileStatus } from '../../../../hooks/useProfileStatus'
import { useTranslation } from 'react-i18next'
import { useUserCourses } from '../../hooks/useCourses'

interface ExpertMentorItemProps {
    profileId: string
    teamNumber?: number
}

const ExpertMentorItem: React.FC<ExpertMentorItemProps> = ({ profileId, teamNumber }) => {
    const { t } = useTranslation('sidebar')
    const { currentCourse } = useUserCourses()
    const myProfileId = currentCourse?.profileId
    const { data } = useProfileStatus(profileId)

    const displayName = data?.displayName || profileId

    const isMyself = profileId === myProfileId
    return (
        <ExpertMentorItemStyled>
            <div className={isMyself ? 'name myself' : 'name'} title={displayName}>
                {displayName}
            </div>
            <div className="right-section">
                {teamNumber && (
                    <div className="team-name">
                        {t('Team')} {teamNumber}
                    </div>
                )}
            </div>
        </ExpertMentorItemStyled>
    )
}

const ExpertMentorItemStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    min-height: 44px;
    color: white;
    gap: 10px;
    padding: 0 15px;

    .myself {
        color: ${props => props.theme.color.blue};
    }

    .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // width: 70%;
        flex: none;
        flex: 1;
    }
    .right-section {
        display: flex;
        align-items: center;
        gap: 10px;
        // width: 30%;
        flex: none;
        button {
            width: 100%;
        }
    }
    .team-name {
        font-size: 12px;
        color: ${props => props.theme.color.gray};
        border: 1px solid ${props => props.theme.color.sidebar.gray1};
        border-radius: 4px;
        padding: 2px 4px;
        min-width: 100px;
        text-align: center;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

export default ExpertMentorItem
